import './ga4';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal';


window.addEventListener('load', function () {
    //
    // fermeture du menu lors du redimensionnement de la fenêtre
    //
    const hamburger = document.querySelector('.offcanvas .hamburger');

    window.addEventListener('resize', () => {
        if (hamburger) {
            hamburger.click();
        }
    });
});